import React from "react";
import Logo from "./Logo";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL } from "../../lib/contact";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#050E1F] text-white/70 border-t border-white/5"
    >
      <div className="container mx-auto px-6 lg:px-8 max-w-7xl py-14">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo variant="light" />
            <p className="mt-5 text-sm leading-relaxed max-w-sm">
              Halı yıkama firmalarına özel halı hurcu (ambalaj) ve kimya çözümleri.
              Profesyonel sonuç için doğru ortak.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-white">
              Bölümler
            </div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><a href="#anasayfa" className="hover:text-white transition-colors">Anasayfa</a></li>
              <li><a href="#hakkimizda" className="hover:text-white transition-colors">Hakkımızda</a></li>
              <li><a href="#urunler" className="hover:text-white transition-colors">Ürünlerimiz</a></li>
              <li><a href="#fiyat-listesi" className="hover:text-white transition-colors">Fiyat Listesi</a></li>
              <li><a href="#ozellikler" className="hover:text-white transition-colors">Özellikler</a></li>
              <li><a href="#blog" className="hover:text-white transition-colors">Blog</a></li>
              <li><a href="#iletisim" className="hover:text-white transition-colors">İletişim</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-white">
              İletişim
            </div>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a
                  href={`tel:${PHONE_TEL}`}
                  className="font-heading font-bold text-white text-lg hover:text-[#60A5FA] transition-colors"
                  data-testid="footer-phone-link"
                >
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                  data-testid="footer-whatsapp-link"
                >
                  WhatsApp üzerinden iletişim
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/50">
          <div>© {year} HALIPAK HALI HURCU &amp; KİMYA. Tüm hakları saklıdır.</div>
          <div>Yerli üretim · Türkiye geneli gönderim</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
